import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateMom from './createMom';
import { getCorpClientList,getClientEmail,createAndSendMom } from 'services/redux/brandActivtion/corporateClient/action';
import {
    getMeetingById,
    cancelMeeting,
    completeMeeting,
} from "services/redux/brandActivtion/meetings/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    meetingById: state.baMeetingReducer.meetingById,
    cancel: state.baMeetingReducer.cancel,
    complete: state.baMeetingReducer.complete,
    corpClientList: state.CorpClientReducer.corpClientList,
    clientEmail: state.CorpClientReducer.corpClientEmail,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMeetingById,
            cancelMeeting,
            completeMeeting,
            getCorpClientList,
            getClientEmail,
            createAndSendMom,
            documentUploadUrlPublic
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(CreateMom);